import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import { CorporateActionFilterUI } from './ui';

export class CorporateActionFilter extends PureComponent {
    static displayName = 'CorporateActionFilterContainer';

    static propTypes = {
        name: PropTypes.string,
        onChange: PropTypes.func,
        value: PropTypes.shape({
            type: PropTypes.string,
            operator: PropTypes.string,
            value: PropTypes.any
        })
    };

    static defaultProps = {
        name: 'corporate-action-filter',
        onChange: undefined,
        value: null
    };

    render() {
        const { name, value, onChange } = this.props;
        return <CorporateActionFilterUI value={value} onChange={onChange} name={name} />;
    }
}

export const CorporateActionFilterContainer = compose()(CorporateActionFilter);
